module.exports = __webpack_public_path__ + "static/full-stack-project-covid-2-ced2560f6957e9ef8e25aecf27293e31.png";